import { useTranslation } from 'react-i18next';
import Button from '../../components/Button/Button';
import useStyles from './styles';

function CompleteOrderButton() {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.completeOrderButtonContainer}>
      <Button
        onClick={
          /* istanbul ignore next */ () => {
            /* do nothing */
          }
        }
        type="primary"
      >
        {t('completeOrder')}
      </Button>
    </div>
  );
}

export default CompleteOrderButton;
